import React from 'react';
import { ProjectCatalogProduct } from '@/types';
import { ProductCard, ProductCardProps } from './ProductCard';
import { Dropdown } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { faEdit, faTrashAlt } from '@fortawesome/pro-light-svg-icons';

export interface ProjectProductCardProps extends Omit<ProductCardProps, 'product'> {
    product: ProjectCatalogProduct;
    onChange?(): void;
    onEditClick?(): void;
    onDeleteClick?(): void;
    dragProps?: object;
    readOnly?: boolean;
    className?: string;
}

export const ProjectProductCard: React.FC<ProjectProductCardProps> = ({
    product,
    onChange,
    dragProps,
    readOnly = true,
    className,
    onEditClick,
    onDeleteClick,
    ...rest
}) => {
    return (
        <>
            <ProductCard
                {...rest}
                className={className}
                product={product}
                catalog="project"
                dropdownContent={
                    product.permissions && (
                        <>
                            <Dropdown.Item icon={faEdit} onClick={onEditClick} disabled={!product.permissions.canEdit}>
                                <Trans>Edit</Trans>
                            </Dropdown.Item>
                            <Dropdown.Item
                                icon={faTrashAlt}
                                onClick={onDeleteClick}
                                disabled={!product.permissions.canDelete}>
                                <Trans>Delete</Trans>
                            </Dropdown.Item>
                        </>
                    )
                }
            />
        </>
    );
};
